import { render, staticRenderFns } from "./WxLink.vue?vue&type=template&id=e5612682&scoped=true"
import script from "./WxLink.vue?vue&type=script&lang=js"
export * from "./WxLink.vue?vue&type=script&lang=js"
import style0 from "./WxLink.vue?vue&type=style&index=0&id=e5612682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5612682",
  null
  
)

export default component.exports